import { IArticle, ICreateArticle } from "../../../models/article.ts";
import { zendeskHttpRequest } from "../zendeskHttpRequest.ts";

export const createArticle = async (
  token: string,
  brandUrl: string,
  article: ICreateArticle,
) => {
  const endpoint = `help_center/sections/${article.section_id}/articles`;
  try {
    const data = await zendeskHttpRequest<{ article: IArticle }>(
      endpoint,
      token,
      "POST",
      brandUrl,
      JSON.stringify({
        article: article,
        notify_subscribers: false,
      }),
    );
    return data.article;
  } catch (error) {
    throw `記事作成エラー(section_id=${article.section_id}): ${error}`;
  }
};
